package one.healthium.health_advice.ui.message

internal data class HealthAdviceMessageUiState(
    val message: String? = null,
)
